import React from "react";
import moment from "moment/moment";

import {component_tool} from "@/tool";


import {stateEnum, getDealerList} from "../util";
import {AuditForm} from './components'


let {WizPopover} = component_tool


let componentName = 'accountConsolidationRecord';

const columns = (self) => {
  return [
    {
      name: "id",
      formItem: {
        type: "hidden"
      }
    },
    {
      title: "账号",
      name: "userName",
      searchItem: {},
    },
    {
      title: "姓名",
      name: "fullName",
      searchItem: {},
    },
    {
      title: "经销商名称",
      name: "dealerName",
      searchItem: {},
    },
    {
      title: "经销商编码",
      name: "dealerCode",
      searchItem: {},
    },
    {
      title: "新账号",
      name: "userNameNew",
      tableItem: {
        dataIndex: "personInfoNew.userName",
      },
    },
    {
      title: "新账号姓名",
      name: "fullNameNew",
      tableItem: {
        dataIndex: "personInfoNew.fullName",
      },
    },
    {
      title: "新账号经销商",
      name: "dealerListNew",
      tableItem: {
        dataIndex: "personInfoNew.identityList_dealer",
        render: (xxx = [], record) => {
          let dealerList = getDealerList(record?.personInfoNew?.identityList);

          let getContent = (data, view) => !!data ?
            <div key={data?.id}>{`${[data?.preSalesNumber, data.afterSalesNumber].filter(item => !!item).join("_")}-${data?.name}`}{view}</div> : null

          return dealerList.length ? (
            <WizPopover
              content={dealerList.map(item => getContent(item))}
              placement="rightTop"
            >
              {getContent(dealerList?.[0] || {}, dealerList.length > 1 ? ' ...' : '')}
            </WizPopover>
          ) : '暂无'
        }
      },
    },
    {
      title: "新账号任职",
      name: "identityListNew",
      tableItem: {
        dataIndex: "personInfoNew.identityList",
        render: (xxx = [], record) => {
          let identityList = record?.personInfoNew?.identityList
          let getContent = (data, view) => !!data ?
            <div key={data?.id}>{`${data?.orgName}-${data?.positionName}`}{view}</div> : null
          return identityList?.length ? (
            <WizPopover
              content={identityList.map(item => getContent(item))}
              placement="rightTop"
            >
              {getContent(identityList?.[0] || {}, identityList.length > 1 ? ' ...' : '')}
            </WizPopover>
          ) : '暂无任职'
        }
      },
    },

    {
      title: "旧账号",
      name: "userNameOld",
      tableItem: {
        dataIndex: "personInfoOld.userName",
      },
    },
    {
      title: "旧账号姓名",
      name: "fullNameOld",
      tableItem: {
        dataIndex: "personInfoOld.fullName",
      },
    },
    {
      title: "旧账号经销商",
      name: "dealerListOld",
      tableItem: {
        dataIndex: "personInfoOld.identityList_dealer",
        render: (xxx = [], record) => {
          let dealerList = getDealerList(record?.personInfoOld?.identityList);

          let getContent = (data, view) => !!data ?
            <div key={data?.id}>{`${[data?.preSalesNumber, data.afterSalesNumber].filter(item => !!item).join("_")}-${data?.name}`}{view}</div> : null

          return dealerList.length ? (
            <WizPopover
              content={dealerList.map(item => getContent(item))}
              placement="rightTop"
            >
              {getContent(dealerList?.[0] || {}, dealerList.length > 1 ? ' ...' : '')}
            </WizPopover>
          ) : '暂无'
        }
      },
    },
    {
      title: "旧账号任职",
      name: "identityListOld",
      tableItem: {
        dataIndex: "personInfoOld.identityList",
        render: (xxx = [], record) => {
          let identityList = record?.personInfoOld?.identityList

          let getContent = (data, view) => !!data ?
            <div key={data?.id}>{`${data?.orgName}-${data?.positionName}`}{view}</div> : null
          return identityList?.length ? (
            <WizPopover
              content={identityList.map((item) => getContent(item))}
              placement="rightTop"
            >
              {getContent(identityList?.[0] || {}, identityList.length > 1 ? ' ...' : '')}
            </WizPopover>
          ) : '暂无任职'
        }
      },
    },
    {
      title: "申请人姓名",
      name: "fullName",
      tableItem: {},
    },
    {
      title: "生成时间",
      name: "createTime",
      tableItem: {},
    },
    {
      title: "申请时间",
      name: "submitTime",
      searchItem: {
        type: 'date~',
        format: 'YYYY-MM-DD',
      },
      tableItem: {},
    },
    {
      title: "状态",
      name: "state",
      dict: Object.keys(stateEnum).map(key => ({code: key, codeName: stateEnum[key]})),
      searchItem: {
        type: 'select',
        formatInit: () => '1',
      },
      tableItem: {
        render: (text, record) => {
          let {state, processState} = record || {}
          if (processState === 2) {
            return stateEnum[`processState_${processState}`]
          }
          return stateEnum[state];
        }
      },
    },
    {
      name: "custom",
      searchItem: {
        type: "custom",
        render: (record, form, otherProps) => {
          self.form = form;
        },
      },
    },
  ]
}

const templateConfig = (self) => {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns(self),
        searchBarProps: {
          collapse: false,
          cols: {
            xs: 24,
            md: 12,
            xl: 8
          },
          dataFormat: (v) => {
            let value = Object.assign([], v)
            let submitTime = value?.submitTime, state = value?.state
            if (submitTime?.length === 2) {
              value.submitStartDate = moment(submitTime[0]).format("YYYY-MM-DD")
              value.submitEndDate = moment(submitTime[1]).format("YYYY-MM-DD")
            } else {
              value.submitStartDate = undefined
              value.submitEndDate = undefined
            }
            if (state?.indexOf('processState_') === 0) {
              value.state = undefined
              value.processState = 2
              value.nonProcessState = undefined
            } else if(state == 2) {
              value.processState = undefined
              value.nonProcessState = 2
            } else {
              value.processState = undefined
              value.nonProcessState = undefined
            }

            return value
          },
          buttonSort: ['review', 'batchReview', 'mergeAccount', 'export'],
          buttons: [
            {
              key: 'review',
              name: 'WizButton',
              params: {
                children: '审核',
                key: 'review',
              },
              onClick: (e) => {
                if (e.rows?.length !== 1) {
                  wizNotice.warn('请选中一条数据');
                  return
                }
                self.jumpPage('push', '/accountConsolidationRecord/detail', e.rows[0])
              },
            },
            {
              key: 'batchReview',
              custom: true,
              params: {children: '批量审核'},
              customOnClick: {
                key: 'modal',
                params: {
                  modalKey: 'batchReview',
                  modalParams: {
                    title: '批量审核',
                    destroyOnClose: true,
                    footer: null,
                    diy: (e) => {
                      let record = e && e.rows
                      return (
                        <>
                          <AuditForm
                            data={record}
                            submit={(data) => {
                              self.changeModal = e.changeModal
                              // e.changeModal(false, true)

                              self.doAction({
                                path: `${componentName}/audit`,
                                payload: {
                                  key: `${componentName}@audit`,
                                  apiParams: {...data}
                                }
                              })
                            }}
                          />
                        </>
                      )
                    },
                    onOk: () => {
                    },
                    onCancel: () => {
                    }
                  }
                }
              },
              recordChangeParams: ({record, rows}) => {
                let disabled = true;
                if (rows?.length > 1) {
                  disabled = false
                }
                return {disabled: disabled}
              },
            },
            {
              key: 'mergeAccount',
              name: 'WizButton',
              params: {
                children: '合并账号',
                key: 'mergeAccount',
              },
              onClick: (e) => {
                self.jumpPage('push', '/accountConsolidationRecord/add')
              },
            },
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams:(rows,record,filters,callback)=>{
                  return {...filters}
                }
              }
            }
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          // rowKey: (record) => (record.bizType + '-' + record.id),
          rowKey: 'id',
          selectType: "checkbox",
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false,
          needOnRowSelect: (record, index) => {
            return record?.state === 1;
          },
          rowSelection: {
            getCheckboxProps: record => ({
              disabled: record?.state !== 1,
            }),
          },
        },
        rowOperateSort: ['look'],
        rowOperateView: [
          {
            key: "look",
            custom: true,
            params: {children: "查看"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/accountConsolidationRecord/detail",
              },
            },
          },
        ],
        commonOperate: {
          mergeAccount: false,
        },
      }
    }
  };
}

const apis = () => {
  return {
    list: {
      path: `${componentName}/list`,
      payload: {
        key: `${componentName}@list`,
        apiParams: {}
      }
    },
    export: {
      path: `${componentName}/export`,
      payload: {
        key: `${componentName}@export`,
        apiParams: {}
      }
    },
    audit: {
      path: `${componentName}/audit`,
      payload: {
        key: `${componentName}@audit`,
        apiParams: {}
      }
    },
  }
}

let reduxTemplateConfig = (args) => {
  return {
    apis: apis(),
    componentName,
    initApiKeys: [],
    keepInitApiParams: true,
    needLoading: true,
    ...args
  }
};

export {reduxTemplateConfig, templateConfig};
